module.exports = __webpack_public_path__ + "static/media/launch_anchorage_marker.a2ae3679.svg";